var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:[{'is-active': _vm.is_open}, 'hamburger', 'hamburger--spin-r',],attrs:{"type":"button"},on:{"click":_vm.burgerSwitch}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])
}]

export { render, staticRenderFns }